export default {
    "光子国际艺术大赛人气奖评选通道正式开启！": "Best Popularity Award Selection gets started NOW!",
    "即日起至11月10日，每位用户可为喜爱的参赛作品点赞（每个用户给每个作品限投1票）。": "From today to November 10th 12:00 noon (CST), all accounts of MANA can vote for your favorite artworks (Each account can vote for one artwork only once). The artwork with most likes will win the Best Popularity Award.",
    "截至2020年11月10日北京时间中午12:00，参赛作品点赞数累计最高者获得最佳人气奖。": "",
    "人气最高": "Popularity",
    "最新加入": "Latest",
    "人气": "Popularity",
    "投票": "Vote",
    "已投票": "Voted",
    "报名须知": "报名须知",
    "查看作品详情": "查看作品详情",
    "查看在线互动DEMO": "查看在线互动DEMO",
    "暂无参赛作品": "暂无参赛作品",
    "光子国际艺术大赛人气奖投票截止！": "Best Popularity Award Selection terminated!",
    "人气值": "Popularity",
    "投票已截止!": "Votes Terminated!",
    "入围作品公布": "Entries Published",
    "企业账户认证": "Corporate Verification",
    "您的账户尚未进行企业认证，认证审核通过后即可发布活动，是否要去认证？": "You need to be verified as a corporate before posting events, process to verify?",
    "立即认证": "Verify Now",
    "最多视频": "Sort by Videos",
    "最多成员": "Sort by Members",
    "创建学习频道": "New Learning Channel",
    "创建高校频道": "New College Channel",
    "播放反馈": "Playing issue",
    "反馈视频": "Reported video",
    "问题描述": "Description",
    "发送反馈": "Send",
    "播放卡顿": "Streaming issue",
    "进度条拖动失败": "Progress bar not working",
    "播放时一直出现加载动画": "Loading animation issue",
    "黑屏": "Black screen",
    "其它": "Other",
    "点击查看": "View Now",
    "年度盘点": "Annual Picks",
    "2020MANA年度全球精选作品盘点": "2020 MANA Global Selected Works",
    "2021MANA年度全球精选作品盘点": "2021 MANA Global Selected Works",
    "预估作品落地成本": "Estimated cost",
    "5万以下": "Below 50K",
    "5-10万": "50-100K",
    "10-30万": "RMB 100-300K",
    "30-50万": "RMB 300-500K",
    "50万以上": "Above RMB 500K",
    "请选择预估作品落地成本": "Please select estimated cost",
    "该竞赛已结束！": "The contest has finished!",

    "上传手持证件照正面": "Image holding ID card info side",
    "请上传手持证件照正面": "Please upload image holding ID card info side",
    "字数限制50-500字": "100-1000 letters",
    "指导老师": "Mentor",
    "选填，请输入指导老师姓名": "Optional, please enter your mentor's name",
    "指导老师手机号": "Mentor's mobile",
    "选填，请输入指导老师手机号": "Optional, please enter your mentor's mobile",
    "在线互动demo URL地址": "Online demo URL",
    "如Realibox等": "e.g. Realibox",
    "选填，在线互动demo URL地址": "Optional, online demo URL",
    "上传附件": "Upload attachments",
    "可上传多个附件(压缩包、PDF等)，每个附件大小不超过100M": "Multi attachments allowed(zip file, pdf etc.), max size 100M",
    "上传": "Upload",
    "文件不能大于100M": "The filesize should be less than100M",
    "文件不能大于10M": "The filesize should be less than10M",
    "时长为1-5分钟，分辨率不小于1920*1080": "Duration 1 to 5 minutes, and minimum resolution 1920*1080px",
    "50-500字": "50-500 Characters",
    "身份": "Identity",
    "当前学习阶段": "Current learning phase",
    "专科": "Junior College",
    "本科": "Undergraduate",
    "研究生": "Postgraduate",
    "学号": "Student No.",
    "请输入学号": "Please enter student No.",
    "通讯地址": "Address",
    "请输入通讯地址": "Please enter address",
    "请输入微信号": "Please enter Wechat ID",
    "如没有微信请输入无": "Please input N/A if you don't have one",
    "注：以下信息仅用于竞赛实名认证，我们将严格保密": "Note: the info's only for this contest, and shall not be uncovered for other purpose",
    "真实姓名": "Real name",
    "请输入真实姓名": "Please enter real name",
    "身份证号码": "ID card No.",
    "请输入身份证号码": "Please enter your ID card No.",
    "认证信息": "Certified info",
    "上传手持身份证照": "Image holding ID card",
    "上传身份证正面照片": "Front image of ID card",
    "上传身份证反面照片": "Back image of ID card",
    "（个人信息面）": "(Info side)",
    "（国徽面）": "(Emblem side)",
    "请上传证件照正面": "Please upload front image of ID card",
    "请上传证件照反面": "Please upload back image of ID card",
    "最多添加10个": "Maximum 10",
    "请选择当前学习阶段": "Please select your studying phase",
    "你的认证信息已审核通过": "You've been certified",
    "认证信息审核中": "Certified info under review",
    "实名认证": "Identity",
    "注销账号": "Delete Account",
    "MANA账号注销后不可恢复": "Deleted accounts can not be reactivated",
    "你的私有数据将被": "All you private data will be ",
    "永久删除": "permanently deleted",
    "建议做好备份": "we recommend you backup everything first",
    "继续注销": "Continue",
    "返回个人中心": "Back to profile",
    "说一下注销的原因吧": "Your reason of deletion",
    "注销成功": "Successfully deleted",
    "后自动返回首页": "Redirecting to homepage in ",
    "其他原因（请填写）": "Other reasons(please enter)",
    "填写理由示例": "Your reason of deletion",
    "请选择注销原因！": "Please select a reason!",
    "入围公示": "Shortlist",
    "选用公示": "Finalist",
    "请输入门票价格": "Please enter ticket price",
    "请选择活动报名开始时间": "Please select event participation start time",
    "请选择活动报名结束时间": "Please select event participation end time",
    "请选择活动举办开始时间": "Please select event start time",
    "请选择活动举办结束时间": "Please select event end time",
    "链接应以http://或 https://开头": "Link must starts with http:// or https://",
    '您已成功提交参赛作品，该作品将会在作品征集截止（2022年9月30日）后同步至竞赛主办方官网“澜景· 未来媒体学院奖”（x）。': 'You have successfully submitted your entry, which will be uploaded to the official website of the competition organizer "Enlightv · Future Media Academy Award" (<a href="https://www.fmaa.cc/" style="color: #2026CC;" target="_blank">{count}</a>) after the deadline of submission (September 30, 2022).',
    '学院奖官网登录账号为您的注册邮箱，默认密码将在作品征集截止后发送至您的邮箱，请注意查收。感谢参与！': 'The login account of the official website (<a href="https://www.fmaa.cc/" style="color: #2026CC;" target="_blank">{count}</a>) is your registered email address. The default password will be sent to your email address after the deadline of submission. Please check it. Thanks for your participation!',
    '暂不支持GIF格式，请上传其它图片': 'GIF is not supported, please select another one',
 }



// WEBPACK FOOTER //
// ./src/languages/en/works.js